export const BASE_URL = process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS
//===========================================================================================
export const EP_LOGIN = '/api/login'
export const EP_USER_LOGIN_2FA = '/api/login/twofa'
export const EP_LOGOUT = '/signout'
export const EP_FRESH_DATA = '/get/fresh/user/data'
export const EP_USER_SIGNUP  = 	'/api/signup'
export const EP_FORGOT_PASSWORD = '/forgot/password'
export const EP_RESET_PASSWORD_FROM_HASH = '/change/via/forgot/password'
export const EP_CHANGE_PASSWORD = '/change/password'
export const EP_REGISTER = '/api/create/lead'
export const EP_OTP_FOR_REGISTER = '/api/verify/otp/lead'
export const EP_USER_PROFILE = '/api/user/profile'

export const EP_REGISTER_OPTIONS = '/api/registration/options'
export const EP_REGISTER_STEP1 = '/api/patient/register/addedit/step1'
export const EP_REGISTER_STEP2 = '/api/patient/register/addedit/step2'
export const EP_REGISTER_STEP3 = '/api/patient/register/addedit/step3'
export const EP_GET_USER_REGISTERATION_STEP_DATA = '/api/patient/register/steps/info'
export const EP_REGISTER_DISEASE_LIST = '/api/registration/disease'

//==========prescription======================
export const EP_PATIENT_PRESCRIPTION_LIST = '/api/service/appprescription/list' // /api/patient/prescription/list
export const EP_PATIENT_PRESCRIPTION_DETAIL = '/api/admin/patient/prescription/view'
export const EP_PATIENT_ADDEDIT_PRESCRIPTION = '/api/patient/prescription/addedit'
//==========test-report======================
export const EP_PATIENT_TEST_REPORT_LIST = '/api/service/uptestreports/list' // /api/user/get/pdfList     old
export const EP_PATIENT_TEST_REPORT_DETAIL = '/api/user/get/pdfDetail'
export const EP_UPLOAD_PATIENT_TEST_REPORT = '/api/service/uptestreports/add'      // /api/user/upload/pdf   old
export const EP_EDIT_PATIENT_TEST_REPORT = '/api/user/edit/pdfJson'
//==========appointment=====================
export const EP_GET_APPOINTMENT_LIST = '/get/appointment/list'
export const EP_GET_APPOINTMENT_DETAIL = '/user/appointment/detail'
export const EP_GET_APPOINTMENT_INFO = '/get/appointment/prescription'
export const EP_ADD_APPOINTMENT = '/user/add/appointment'
export const EP_GET_AVAILABLE_SLOTS_LIST = '/get/available/slots'// /api/user/get/slots
export const EP_GET_BUSY_SLOT_LIST = '/check/busy/slot'
export const EP_GET_PATIENT_BUSY_SLOT = '/check/booked/dates'
export const EP_GET_DOCTOR_DETAIL = '/get/admin/details'

//====================obt call=============================
export const EP_BOOK_OBT_CALL = '/user/lead/allocation/add'
export const EP_CHECK_OBT_CALL = '/user/obt/call/done/check'

//==========notification=====================
export const EP_GET_NOTIFICATION_LIST = '/api/user/notification/list'

export const EP_INITIAL_DATA = '/api/userstat/data'
export const EP_CHART_DATA = '/api/user/chart/data'
export const EP_CHART_HISTORY = '/api/user/chart/history'

export const EP_ADD_FOOD_INTAKE = '/add/food/data/collection'
export const EP_ADD_WEIGHT = '/add/weight/data/collection'
export const EP_ADD_BLOOD_PRESSURE = '/add/equipment/data/collection'
export const EP_ADD_GLUCOSE_DATA = '/api/user/gulcose/addedit'
export const EP_ADD_EMOTION_DATA = '/add/emotion/data/collection'
export const EP_ADD_DIGESTION_DATA = '/add/poop/data/collection'
export const EP_ADD_SLEEP_DATA = '/api/user/addsleep'

export const EP_GET_MEDICINE_LIST = '/api/pres/medicine/list'

export const EP_GET_TASK_ACTION_LIST = '/api/service/apptaskaction/list'

export const EP_EDIT_PROFILE = '/api/update'
export const EP_EDIT_PROFILE_PIC = '/api/pic/update'













// WEBPACK FOOTER //
// ./src/store/api/endpoints.js